import { Box, Button, Card, CardContent, Checkbox, Collapse, Dialog, Divider, Drawer, FormControl, IconButton, List, ListItemButton, ListItemText, MenuItem, Select, Switch, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Load";
//import { onChange } from "store/slices/fbs-fbo";
import { delFts, getFile, post, postImage } from "api/apiBridges/httpBridge";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import Scrollbars from "rc-scrollbars";
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from "store/slices/marketClient";
import { get } from "api/apiBridges/httpBridge"
import { useLocalNotifications } from "components/Events";
import { SelectProductTocopy } from "components/EIComponents/ProductInfo";
import ClassicSearch from "components/classicSearch";
import { colors } from 'styles/colors';
import usePreventDoubleClick from "components/AntiDBC";
import { SocketContext } from "components/socketLib/ConnectorSocket";
import { onChangeUploadImage } from "store/slices/uploadImage";
import NoPhoto from '../images/others/noPhoto.png';
import { NumInput, TextInput, TextNumInput } from "components/EIComponents/LittleComponents";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { StyledTab } from "utils/formatters";
import { TabPanel } from "components/tabPanel";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ShowModal } from "components/Modal";
import { ElementInfo } from "components/ElementInfo";
import { hoverStyle } from "styles/main";


export function ClientWorkers() {
    const [tab, setTab] = useState(0);
    // @ts-ignore
    const handleChange = (event, newTab) => {
      setTab(newTab);
    };


    return (
      <Box sx={{ width: '100%', height: '100%'}}>
        {/* <FindTextField styleAround={{ padding: '1% 10% 1% 1%' }}></FindTextField>    */}
    
        <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
            "& .MuiTabs-indicator": {
                display: "none"
            },
            margin: '0% 0% 1% 1%',
            paddingTop: "1%",
            height: "8%"
        }}>

            <StyledTab label="Список сотрудников" />
            {/* <StyledTab label="Роли" /> */}
        </Tabs>
        <TabPanel value={0} select={tab}>
            {<WorkerList/>}
        </TabPanel>
        {/* <TabPanel value={1} select={tab}>
            {<RolesList/>}
        </TabPanel> */}

    </Box>
    )
}

function WorkerList () {

    const [workers, setWorkers] = useState([])
    const [roles, setRoles] = useState([])
    const [loading, setLoading] = useState(true);
    const [workerSettings, setWorkerSetting] = useState(
        { 
            open: false, 
            ds: undefined, 
            data: undefined
        }
    )
    const ds = useMemo(() => getDataSource('cliWorkerList'), []);
    const { user_id} = useSelector(
        loginSelector
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const responseData = await get('ClientsWorkers/getOnClientId', {uid:user_id});
                console.log(responseData)
                // люблю
                responseData.map((el) => {el.open = false})
                
                
                const responseRoles = await get('ClientsRoles/getClientIdRoles', {cid:user_id});
                let res = []
                if (responseRoles){
                responseRoles.map((el) => {
                    let rules = []
                    el.rules.map((rule) => {rules.push({id:rule, active:true})})
                    res.push({id:el.id, company_id:el.company_id, title:el.title, rules})
                })
                }
                setRoles(res);

                responseData.map((el) => {
                  let tmp = []
                  el.rules.map((r) => {
                    let idx = res.findIndex((fel) => fel.id === r)
                    if (idx>-1) {tmp.push(res[idx].title)}
                  })
                  el.roles = tmp
                })
                setWorkers(responseData)

            } catch (err) {
            } finally {
            setLoading(false);
            }
        };

        fetchData();
    }, []); 

    const addWorker = async (worker) => {
        console.log("worker", worker)
        let tmp = JSON.parse(JSON.stringify(workers))

        let tmpRoles = []
        worker.rules.map((r) => {
          let idx = roles.findIndex((fel) => fel.id === r)
          if (idx>-1) {tmpRoles.push(roles[idx].title)}
        })
        worker.roles = tmpRoles

        tmp.push(worker)
        setWorkers(tmp)
    }

    const updateWorker = async (worker) => {
        console.log("worker", worker)
        let tmp = JSON.parse(JSON.stringify(workers))
        let idx = tmp.findIndex((el) => el.id === worker.id)
        
        let tmpRoles = []
        worker.rules.map((r) => {
          let idx = roles.findIndex((fel) => fel.id === r)
          if (idx>-1) {tmpRoles.push(roles[idx].title)}
        })
        worker.roles = tmpRoles

        tmp[idx] = worker
        setWorkers(tmp)
    }

    const delWorker = async (id) => {
        let tmp = JSON.parse(JSON.stringify(workers)).filter((el) => el.id !== id)
        setWorkers(tmp)
    }

    // Добавление. Также открывается шторка
    const AddNode = () => {
        setWorkerSetting({ open: true, ds: "addClientWorker", data: {add: addWorker} })
    }

    // Редактировать. Открывается шторка с данными сотрудника
    const EditNode = (worker) => {
        setWorkerSetting({ open: true, ds: "editClientWorker", data: {...worker, update: updateWorker, del: delWorker }})
    }

    const addRole = (role) => {
        setRoles([...roles, role])
    }

    const delRole = (rid) => {
        let tmp = JSON.parse(JSON.stringify(roles))
        tmp = tmp.filter((el) => el.id !== rid)
        setRoles(tmp)
        //TODO удаление роли у всех сотрудников
    }

  if (loading) return (<Loading></Loading>)

  return (
    <>

          {/* <Dialog
              open={dOpen}
              maxWidth='lg'
              PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
              onClose={() => { setDOpen(false) }}
          >
              <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
                  <AddProductToBox data={data["0"] || []} cancel={setDOpen} onSave={onAddProduct}></AddProductToBox>
              </div>

          </Dialog> */}

          <div style={{ display: 'flex', flexDirection: "row", height: "85%", paddingTop: '0px' }}>
              <Card sx={{ borderRadius: 3, boxShadow: 5, margin: "15px", width: "65%", height: "100%" }}>
                <Scrollbars
                    style={{ height: "85%" }}
                    autoHide
                >
                      <CardContent>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginBottom: "15px"}}>
                          <Button
                              onClick={() => AddNode()}
                              variant="contained"
                              size="medium"
                              sx={{
                                  textTransform: "none",
                                  fontWeight: "bold",
                                  px: 3,
                              }}
                          >
                              Добавить сотрудника
                          </Button>
                        </div>
                          <ReportTable
                            ds={ds}
                            data={workers}
                            aditionalAction={
                                [
                                    {
                                        action: (item) => { EditNode(item) },
                                        ui: () => {
                                            return (
                                                <EditIcon 
                                                  sx={{
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': hoverStyle
                                                  }
                                                }/>
                                            )
                                        }
                                    }
                                ]
                            }
                        />
                      </CardContent>
                  </Scrollbars>
              </Card>
              <Card sx={{ borderRadius: 3, boxShadow: 5, margin: "15px", width: "30%", height: "100%" }}>
                <Scrollbars
                    style={{ height: "85%" }}
                    autoHide
                >
                    <CardContent>
                        <ClientRoles roles={roles} addRole={(role) => {addRole(role)}} deleteRole={(rid) => {delRole(rid)}}/>
                    </CardContent>
                </Scrollbars>
              </Card>
          </div>
          <Drawer
            anchor='right'
            open={workerSettings.open}
            onClose={() => {
              setWorkerSetting(
                { 
                  open: false, 
                  ds: undefined, 
                  data: undefined
                }
              )
            }}
          >
            <ElementInfo ds={getDataSource(workerSettings.ds)} data={workerSettings.data} 
              onClose={() => {
                setWorkerSetting(
                  { 
                    open: false, 
                    ds: undefined, 
                    data: undefined
                  }
                )
              }} 
              setChanged={() => {}}
            />
          </Drawer>
      </>
    );
}

function ClientRoles({roles, addRole, deleteRole}){
  const [$data, $setdata] = useState([]);
  const ds = getDataSource('ClientsRoles')
  
  const { user_id } = useSelector(
    loginSelector
  );

//   const [canChange, setCanChange] = useState(rules.includes("admin") || rules.includes("company.change_roles"));
    const [canChange, setCanChange] = useState(true);
  const preventDoubleClick = usePreventDoubleClick();

  

  useEffect(() => {
    console.log("input", roles)
    $setdata(roles)
  }, [roles]); 

  //todo добавить права
  const addNewRole = async () => {
    let name =`Новая роль ${$data.length + 1}`
    let role = await post('ClientsRoles/create', 
      {
        client_id: user_id, 
        title: name, 
        rules:[]
      }
    )
    // $setdata([...$data, {id:role.message.id, title:name, rules:[]}])
    addRole({id:role.message.id, title:name, rules:[]})
  }

  const delRole = async (rid) => {
    try {
        // setLoading(true)
        let tmp = JSON.parse(JSON.stringify($data))
        await post("ClientsRoles/del", {id: rid})
        // tmp = tmp.filter((el) => el.id !== rid)
        //$setdata(tmp)
        deleteRole(rid)
    }
    catch (err) {}
    finally {
        // setLoading(false)
    }
    
  }

//   if (loading) {
//     return (<Loading></Loading>);
//   }

  console.log("Roles", $data)
  return (
    <>
      <div style={{display: 'flex', flexDirection: "column", alignItems: 'center', height: "90%", justifyContent: "flex-start"}}>
          {$data.map((item) => {
            return(
              <Role data={item} ds={ds} canChange={canChange} onDel={delRole}/>
            )
          })}
        {canChange && <Button onClick={preventDoubleClick(addNewRole, 1000)}>Добавить роль </Button>}
      </div>
    </>
  );
}

function Role({data, ds, canChange, onDel}){

  console.log(data, ds)

  const [$data, $setdata] = useState(data);
  let [open, setOpen] = useState(false);
  let [changed, setChanged] = useState(false);

  const ListHandleClick = () => {
    setOpen(JSON.parse(JSON.stringify(!open)));
  };


  const HandleClick = async (id) => {
    let tmp = JSON.parse(JSON.stringify($data))
    const idx = tmp.rules.findIndex((el) => el.id === id);
    console.log(idx)
    if (idx >= 0) {
      tmp.rules[idx] = {id:id, active:!tmp.rules[idx].active}
    }
    else {tmp.rules.push({id:id, active:true})}
    console.log(tmp.rules)
    let arules = []
    tmp.rules.map((rule) => {
      if (rule.active) arules.push(rule.id)
    })
    $setdata(tmp);
    setChanged(true)
  }

  const setName = (val) => {
    let tmp = JSON.parse(JSON.stringify($data))
    tmp.title = val
    $setdata(tmp)
    setChanged(true)
  }

  const save = async () => {
    console.log("save", $data)
    let obj = {
      id: $data.id,
      title: $data.title,
      rules: $data.rules.filter(item => item.active).map(item => item.id)
    }
    setChanged(false)
    await post('ClientsRoles/update', obj)
  }

  const handleClickDelRole = () => {
    ShowModal('Удалить роль', 
    <div>Вы уверены, что хотите удалить роль? Она будет удалена у всех сотрудников</div>, 
    async () => {
        try {
          onDel(data.id)
        }
        catch (err) {}
        finally {}
        
    });
  }

  return (
    <>
      <div style={{width: "100%"}}>
        <ListItemButton onClick={() => ListHandleClick()}>
          <ListItemText primary={$data.title} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>  
        <Collapse in={open} timeout="auto" unmountOnExit>
          <div style={{margin: "5px", display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'space-between'}}>
            <TextInput 
              title="Название роли" 
              val={$data.title} 
              onChange={(e) => setName(e)} 
            />
            {canChange && 
              <Tooltip title="Удалить роль">
                <IconButton onClick={handleClickDelRole}>
                  <DeleteIcon
                    sx={{
                      transition: 'all 0.3s ease',
                      '&:hover': hoverStyle
                    }}
                  />
                </IconButton>
              </Tooltip>
            }
          </div>
          <List component="div" disablePadding  style={{display:"flex", flexDirection:'column'}}>
              {
                ds.descr.rules.map((rule) => (
                  <div style={{display:"flex", flexDirection:'row', alignItems:"center", borderRadius:'10px', backgroundColor:"#cfcfd4", margin:"5px"}}> 
                    <Switch
                        color="primary"
                        checked={$data.rules.find((el) => el.id == rule.id)?.active || false}
                        onClick={() => HandleClick(rule.id)}
                        disabled={!canChange}
                    />
                    {rule.title}
                  </div>
                ))
              }
            </List>
            <div style={{ marginTop: '10px', width: '100%' }}>
                <Divider orientation="horizontal" sx={{ borderRightWidth: "4px" }} />
            </div>
        </Collapse>
        {canChange && changed && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '5px' }}>
            <Button 
              onClick={save} 
              variant="contained" 
              sx={{ 
                textTransform: 'none', 
                backgroundColor: colors.elements, 
                fontWeight: 'bold' 
              }}
            >
              Сохранить
            </Button>
          </div>
        )}
      </div>
    </>
  )
}

